import script from "./SectionRegenerateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionRegenerateDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SectionRegenerateDialog.vue?vue&type=style&index=0&id=3676cdda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3676cdda"]])

export default __exports__